import { WalletError, type ApiClient } from '@cef-ai/wallet-api-client';
import type { Identity } from '@cef-ai/wallet-identity';
import type { HostToPopup, PopupToHost } from '@cef-ai/wallet';
import type { AppContextStore } from '~/stores';

export interface SaveApplicationHandlerDeps {
  identity: Identity;
  apiClient: ApiClient;
  appContextStore: AppContextStore;
  send: (msg: PopupToHost) => void;
}

export function createSaveApplicationHandler(deps: SaveApplicationHandlerDeps) {
  return async (
    msg: Extract<HostToPopup, { type: 'wallet:saveApplication' }>,
    _meta: { origin: string },
  ): Promise<void> => {
    if (!deps.identity.isAuthenticated) {
      throw new WalletError('unauthorized', 'saveApplication: not logged in');
    }
    const appId = deps.appContextStore.app.appId;
    const result = await deps.apiClient.applications.save({
      appId,
      permissions: msg.permissions,
      email: msg.email,
    });
    deps.send({ type: 'wallet:result', id: msg.id, result });
  };
}
